<template>
  <div class="wrap">
    <div class="inner sub_survey editor">
      <div class="bx_notice_write bx_write">
        <div class="a_list">
          <div class="info">
            <ul>
              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_enrolmentTitle')}}</div>
                <div class="info_txt">
                                    <TextArea
                                        ref="title"
                                        id="title"
                                        cols="50"
                                        rows="1"
                                        :maxlength="40"
                                        :placeholder="$t('EnrolmentEditor_inputEnrolmentTitle')"
                                        :show-count="true"
                                        v-model="title"
                                        :resize="true"
                                        :one-line="true"
                                        wrapper-class="tit_survey"
                                    />
                </div>
              </li>
              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_enrolmentDesc')}}</div>
                <div class="info_txt">
                                    <TextArea
                                        ref="surveyDesc"
                                        id="surveyDesc"
                                        cols="50"
                                        rows="5"
                                        :maxlength="2000"
                                        :placeholder="$t('EnrolmentEditor_inputEnrolmentDesc')"
                                        v-model="surveyDesc"
                                        :resize="true"
                                        :max-height="182"
                                    />
                </div>
              </li>

              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_imageAttach')}}</div>
                <div class="info_txt">

                  <ImageUpload
                      v-slot="{openFileDialog}"
                      v-on:requestUpload="uploadImage"
                      :now-count="images.length"
                      :max-count="maxImageCount"
                      :multiple="true"
                      v-ga-helper:click.vueEvent="gaImageUploadEnrol"
                  >
                    <button type="button" class="btn btn_attach" @click.prevent="openFileDialog">
                      <span class="sp ico_plus3"></span>{{$t('EnrolmentEditor_attachImage')}}
                    </button>
                  </ImageUpload>

                  <!-- [D] 첨부 이미지 -->
                  <ul class="lst_include_file" v-if="showImages">
                    <li v-for="image in images" class="bx_include_file">
                      <div class="image">
                        <img :src="image.url" width="580" alt="">
                        <button type="button" class="btn_delete"
                                v-on:click.prevent="deleteImage({imageKey: image.imageKey})">
                          <span class="sp">{{$t('EnrolmentEditor_deleteImage')}}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                  <span class="copy"><span :class="{txt_color: showImages}">{{ images.length }}</span>/{{$t('common_count', {count: maxImageCount})}}, {{$t('common_maximumSizePerImage')}}</span>
                </div>
              </li>

              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_documentAttach')}}</div>
                <div class="info_txt">
                  <DocumentUpload
                      v-slot="{openFileDialog}"
                      v-on:requestUpload="uploadDocument"
                      :now-count="documents.length"
                      :max-count="maxDocumentCount"
                      :multiple="true"
                      v-ga-helper:click.vueEvent="gaDocumentUpload"
                  >
                    <button type="button" class="btn btn_attach" @click.prevent="openFileDialog">
                      <span class="sp ico_plus3"></span>{{$t('EnrolmentEditor_attachDocument')}}
                    </button>
                  </DocumentUpload>

                  <!-- [D] 첨부 파일 -->
                  <ul class="lst_include_file no_margin" v-if="showDocuments">
                    <template v-for="document in documents">
                      <Document
                          :id="document.documentKey"
                          :upload-state="document.uploadState"
                          :file-name="document.fileName"
                          :file-size="document.fileSize"
                          :percent="document.uploadPercent"
                          :document-no="document.documentNo"
                          :token-key="document.tokenKey"
                          v-on:downloadTempDocument="downloadTempDocument"
                          v-on:deleteDocument="deleteDocument"
                          v-on:retry="retryDocument"
                      />
                    </template>
                  </ul>

                  <form ref="downloadForm" :action="downloadForm.action" :method="downloadForm.method"
                        target="_download_frame"
                        enctype="application/x-www-form-urlencoded"></form>
                  <iframe width="0" height="0" style="width:0;height:0;border:0"
                          name="_download_frame" tabindex="-1"></iframe>

                  <span class="copy"><span
                      :class="{txt_color: showDocuments}">{{ documents.length }}</span>/{{$t('common_count', {count: maxDocumentCount})}} {{$t('EnrolmentEditor_documentAttachDesc')}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="a_list">
          <div class="set">
            <h3 class="st">{{$t('EnrolmentEditor_enrolmentSettings')}}</h3>
            <ul>
              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_selectionMethod')}}</div>
                <div class="info_txt">
                  <div class="area_choice">
                                        <span class="bx_input_rdo" v-on:mouseDown.stop="noop" v-on:mouseup.stop="noop">
                                            <input type="radio" name="type" id="typeRandom" class="input_rdo"
                                                   :value="consts.ENROLMENT_TYPE.RANDOM"
                                                   checked
                                                   v-model="enrolmentType"
                                                   v-ga-helper:change="{
                                                      view_category: '수강신청작성',
                                                      view_area: '선정방식옵션클릭',
                                                      view_label: '수동추첨',
                                                   }"
                                            >
                                            <label for="typeRandom"
                                                   class="input_lbl">{{ $t('EnrolmentEditor_randomMethod') }}</label>
                                        </span>
                    <span class="bx_input_rdo" v-on:mousedown.stop="noop" v-on:mouseup.stop="noop">
                                            <input type="radio" name="type" id="typeFcfs" class="input_rdo"
                                                   :value="consts.ENROLMENT_TYPE.FCFS"
                                                   v-model="enrolmentType"
                                                   v-ga-helper:change="{
                                                      view_category: '수강신청작성',
                                                      view_area: '선정방식옵션클릭',
                                                      view_label: '정원선착순마감',
                                                   }"
                                            >
                                            <label for="typeFcfs"
                                                   class="input_lbl">{{ $t('EnrolmentEditor_fcfsMethod') }}</label>
                                        </span>
                    <span class="bx_input_rdo">
                                            <input type="radio" name="type" id="typeAutoDrawing" class="input_rdo"
                                                   :value="consts.ENROLMENT_TYPE.DRAW_PRIOR"
                                                   v-model="enrolmentType"
                                                   @input="toggleAllowDuplicateApply"
                                                   v-ga-helper:change="{
                                                      view_category: '수강신청작성',
                                                      view_area: '선정방식옵션클릭',
                                                      view_label: '우선순위자동추첨',
                                                   }"
                                            >
                                            <label for="typeAutoDrawing"
                                                   class="input_lbl">{{ $t('EnrolmentEditor_autoDrawing') }}</label>
                                        </span>
                  </div>
                </div>
              </li>
              <li class="list_lottery">
                <div class="info_lbl">{{ $t('EnrolmentEditor_startDate') }}</div>
                <div class="info_txt">
                  <div class="reserve_message" :class="{disabled: isNotUseStartDate}">
                    <TUIDatepickerInput ref="startDate" id="startDate" v-model="startDate"
                                        :lang="$i18n.locale"/>

                    <CustomSelect class="bx_sorting2 hour" v-model="startHour"
                                  :options="select.hour.options" :is-show-arrow="false"
                                  :fit-width="false"/>
                    <span class="txt"> : </span>
                    <CustomSelect class="bx_sorting2 minutes" v-model="startMinute"
                                  :options="select.minute.options" :is-show-arrow="false"
                                  :fit-width="false" placement="bottom-end"/>
                  </div>
                  <span class="bx_input_chk">
                                        <input type="checkbox" class="input_chk" id="startDateNotUse"
                                               v-model="isNotUseStartDate"
                                               v-ga-helper:change="gaIsNotUseStartDate"
                                        >
                                        <label for="startDateNotUse"
                                               class="input_lbl">{{$t('EnrolmentEditor_startDate_notUse')}}</label>
                                    </span>
                </div>
              </li>
              <li>
                <div class="info_lbl">{{$t('EnrolmentEditor_endDate')}}</div>
                <div class="info_txt">
                  <div class="reserve_message">
                    <TUIDatepickerInput ref="endDate" id="endDate" v-model="endDate"/>

                    <CustomSelect class="bx_sorting2 hour" v-model="endHour"
                                  :options="select.hour.options" :is-show-arrow="false"
                                  :fit-width="false"/>
                    <span class="txt"> : </span>
                    <CustomSelect class="bx_sorting2 minutes" v-model="endMinute"
                                  :options="select.minute.options" :is-show-arrow="false"
                                  :fit-width="false" placement="bottom-end"/>
                  </div>
                </div>
              </li>
              <li v-show="isShowDrawingDate" class="list_lottery">
                <div class="info_lbl">{{$t('EnrolmentEditor_drawingDate')}}</div>
                <div class="info_txt">
                  <div class="reserve_message" :class="{disabled: isNotUseDrawingDate}">
                    <TUIDatepickerInput ref="drawingDate" id="drawingDate" v-model="drawingDate"
                                        :lang="$i18n.locale"/>

                    <CustomSelect class="bx_sorting2 hour" v-model="drawingHour"
                                  :options="select.hour.options" :is-show-arrow="false"
                                  :fit-width="false"/>
                    <span class="txt"> : </span>
                    <CustomSelect class="bx_sorting2 minutes" v-model="drawingMinute"
                                  :options="select.minute.options" :is-show-arrow="false"
                                  :fit-width="false" placement="bottom-end"/>
                  </div>
                  <span class="bx_input_chk">
                                        <input type="checkbox" class="input_chk" id="drawingDateNotUse"
                                               v-model="isNotUseDrawingDate"
                                               v-ga-helper:change="gaDrawingDateNotUse"
                                        >
                                        <label for="drawingDateNotUse"
                                               class="input_lbl">{{$t('EnrolmentEditor_drawingDate_notUse')}}</label>
                                    </span>
                </div>
              </li>
            </ul>
            <div v-show="isShowDrawingDate" class="info_lottery">
              <strong class="tit">{{$t('EnrolmentEditor_autoDrawing_info_title')}}</strong>
              <ul>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc1')"></li>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc2')"></li>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc3')"></li>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc4')"></li>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc5')"></li>
                <li v-html="$t('EnrolmentEditor_autoDrawing_info_desc6')"></li>
              </ul>
            </div>
          </div>
        </div>

          <div class="a_list">
              <div class="set">
                  <h3 class="st">개인정보 수집·이용 동의</h3>
                  <ul>
                      <li>
                          <div class="info_lbl">사용 여부</div>
                          <div class="info_txt">
                              <div class="area_choice">
                                  <span class="bx_input_rdo" v-on:mouseDown.stop="noop" v-on:mouseup.stop="noop">
                                      <input type="radio" name="agreement" id="useAgreementFalse" class="input_rdo"
                                             :value="false"
                                             v-model="isUseAgreements"
                                      >
                                      <label for="useAgreementFalse"
                                             class="input_lbl">사용 안함</label>
                                  </span>
                                  <span class="bx_input_rdo" v-on:mousedown.stop="noop" v-on:mouseup.stop="noop">
                                      <input type="radio" name="agreement" id="useAgreementTrue" class="input_rdo"
                                             :value="true"
                                             v-model="isUseAgreements"
                                      >
                                      <label for="useAgreementTrue"
                                             class="input_lbl">사용</label>
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li v-if="isUseAgreements">
                          <EnrolmentEditorAgreementList ref="agree_list"/>
                      </li>
                  </ul>
              </div>
          </div>

        <div class="a_list">
          <EnrolmentEditorQuestionList ref="list"/>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import TextInput from '@/iamteacherpc/components/common/TextInput.vue';
import TextArea from '@/iamteacherpc/components/common/TextArea.vue';
import DocumentUpload from '@/iamteacherpc/components/common/DocumentUpload.vue';
import TUIDatepickerInput from '@/iamteacherpc/components/common/TUIDatepickerInput.vue';
import CustomSelect from '@/iamteacherpc/components/common/CustomSelect.vue';
import {mapFields} from 'vuex-map-fields';
import {ENROLMENT_TYPE} from '@/common/consts/survey.js';
import EnrolmentEditorQuestionList from '@/iamteacherpc/components/editor/EnrolmentEditorQuestionList.vue';
import {iframeResizeEnd, iframeResizeStart, inIframe} from '@/iamteacherpc/utils/iframe.js';
import {createNamespacedHelpers, mapGetters} from 'vuex';
import enrolment, {
  DELETE_IMAGE,
  GET_FILTER_INDEX,
  GET_PAYLOAD,
  GET_REQUEST_INFO,
  getInitForm,
  getIntTime,
  INIT,
  SET_ALLOW_DUPLICATE_APPLY,
  SET_FORM_DATA,
  SET_FORM_DATA_FROM_REQUEST_INFO,
  UPLOAD_IMAGE,
} from '@/common/store/modules/enrolment/editor.js';
import store from '@/common/store';
import ImageUpload from '@/iamteacherpc/components/common/ImageUpload.vue';
import Document from '@/iamteacherpc/components/common/Document.vue';
import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import editorImageDocument from '@/iamteacherpc/mixins/editorImageDocument.js';
import {DELETE_DOCUMENT, RETRY_DOCUMENT, UPLOAD_DOCUMENT} from '@/common/store/modules/common/editor/document.js';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@/common/store/modules/common/editor/questionList.js';
import {MAX_IMAGE_DEFAULT_COUNT} from '@/iamteacherpc/consts/image.js';
import {MAX_DOCUMENT_DEFAULT_COUNT} from '@/iamteacherpc/consts/document.js';
import usePromise from "@iamteacherpc/utils/usePromise";
import ACCEPTED_DOMAIN from "@common/consts/accepted-domain";
import EnrolmentEditorAgreementList from '@iamteacherpc/components/editor/EnrolmentEditorAgreementList.vue';

const {mapActions} = createNamespacedHelpers('enrolment');

if (!store.state.enrolment) {
  store.registerModule('enrolment', enrolment);
}

export default {
  components: {
      EnrolmentEditorAgreementList,
    Document,
    ImageUpload,
    EnrolmentEditorQuestionList,
    CustomSelect,
    DocumentUpload,
    TextArea,
    TextInput,
    TUIDatepickerInput,
  },

  mixins: [
    editorImageDocument
  ],

  metaInfo() {
    const title = this.$t('common_enrolment');
    return {title}
  },

  data() {
    return {
      select: {
        hour: {
          options: (() => {
            const options = [];
            for (let i = 0; i < 24; i++) {
              options.push({value: i, label: i < 10 ? '0' + i : '' + i});
            }
            return options;
          })()
        },
        minute: {
          options: (() => {
            const options = [];
            for (let i = 0; i < 60; i += 10) {
              options.push({value: i, label: i === 0 ? '00' : '' + i});
            }
            return options;
          })()
        }
      },
      consts: {
        ENROLMENT_TYPE,
      },
      maxImageCount: MAX_IMAGE_DEFAULT_COUNT,
      maxDocumentCount: MAX_DOCUMENT_DEFAULT_COUNT,

      downloadForm: {
        action: '',
        method: '',
      },

      UICompleted: null,

      filterOptions: null,
      resolveFunc: null,
      clearResolveFunc: null,
    }
  },

  computed: {
    ...mapFields('enrolment', [
        'form.title',
        'form.surveyDesc',
        'form.images',
        'form.documents',
        'form.isUseStartDate',
        'form.isUseDrawingDate',
        'form.startDate',
        'form.endDate',
        'form.drawingDate',
        'form.enrolmentType',
        'form.questions',
        'form.isAllowDuplicateApply',
        'form.isUseAgreements',
        'form.agreements',
    ]),

    ...mapGetters('enrolment', [
      GET_FILTER_INDEX,
      GET_PAYLOAD,
      GET_REQUEST_INFO,
    ]),

    showDocuments() {
      return this.documents.length > 0;
    },

    showImages() {
      return this.images.some(image => image.uploadState === REQUEST_STATE.SUCCESS);
    },

    startHour: {
      get() {
        return this.startDate.getHours();
      },
      set(newValue) {
        const newDate = new Date(this.startDate);
        newDate.setHours(newValue);
        this.startDate = newDate;
      }
    },

    startMinute: {
      get() {
        return this.startDate.getMinutes();
      },
      set(newValue) {
        const newDate = new Date(this.startDate);
        newDate.setMinutes(newValue);
        this.startDate = newDate;
      }
    },

    endHour: {
      get() {
        return this.endDate.getHours();
      },
      set(newValue) {
        const newDate = new Date(this.endDate);
        newDate.setHours(newValue);
        this.endDate = newDate;
      }
    },

    endMinute: {
      get() {
        return this.endDate.getMinutes();
      },
      set(newValue) {
        const newDate = new Date(this.endDate);
        newDate.setMinutes(newValue);
        this.endDate = newDate;
      },
    },

    drawingHour: {
      get() {
        return this.drawingDate.getHours();
      },
      set(newValue) {
        const newDate = new Date(this.drawingDate);
        newDate.setHours(newValue);
        this.drawingDate = newDate;
      },
    },

    drawingMinute: {
      get() {
        return this.drawingDate.getMinutes();
      },
      set(newValue) {
        const newDate = new Date(this.drawingDate);
        newDate.setMinutes(newValue);
        this.drawingDate = newDate;
      },
    },

    startDateTime() {
      return new Date(this.startDate).setHours(this.startHour, this.startMinute, 0, 0);
    },

    endDateTime() {
      return new Date(this.endDate).setHours(this.endHour, this.endMinute, 0, 0);
    },

    isNotUseStartDate: {
      get() {
        return !this.isUseStartDate;
      },
      set(newValue) {
        this.isUseStartDate = !newValue;
      },
    },

    isNotUseDrawingDate: {
      get() {
        return !this.isUseDrawingDate;
      },
      set(newValue) {
        this.isUseDrawingDate = !newValue;
      },
    },

    isShowDrawingDate() {
      return this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
    },
  },

  watch: {
      endDate() {
          if (this.isNotUseDrawingDate) {
              this.drawingDate = this.endDate;
          }
      },

      isNotUseDrawingDate(value) {
          if (value) {
              this.drawingDate = this.endDate;
          }
      },

      enrolmentType() {
          // enrolmentType 변경시 isAllowDuplicateApply를 각 유형 디폴트 값으로 변경 (우선순위추첨 = false, 나머지 = true)
          // this.isAllowDuplicateApply = true;

        /**
         * 2024.05.28 QA-19301 태스크 참고, 동시간대 중복 신청 불가 체크박스 임시저장시 제대로 저장 안되는 현상 수정
         */
        if (value === ENROLMENT_TYPE.DRAW_PRIOR) {
            this.isAllowDuplicateApply = false;
          } else {
            this.isAllowDuplicateApply = true;
          }
      },
  },

  methods: {
    ...mapActions({
      storeInit: INIT,
      stopListChange: STOP_LIST_CHANGE,
      listChange: LIST_CHANGE,
      setFormData: SET_FORM_DATA,
      setFormDataFromRequestInfo: SET_FORM_DATA_FROM_REQUEST_INFO,
      storeUploadImage: UPLOAD_IMAGE,
      storeDeleteImage: DELETE_IMAGE,
      storeUploadDocument: UPLOAD_DOCUMENT,
      storeDeleteDocument: DELETE_DOCUMENT,
      storeRetryDocument: RETRY_DOCUMENT,
      setAllowDuplicateApply: SET_ALLOW_DUPLICATE_APPLY,
    }),

        /**
         * ga 메소드
         */
        gaImageUploadEnrol() {
            return {
                view_category: '수강신청작성',
                view_area: '이미지첨부하기클릭',
                view_label: '',
            }
        },

        gaDocumentUpload() {
            return {
              view_category: '수강신청작성',
              view_area: '문서첨부하기클릭',
              view_label: '',
            }
        },

        gaDrawingDateNotUse(event) {
            return {
                view_category: '수강신청작성',
                view_area: '마감즉시추첨진행클릭',
                view_label: `마감즉시추첨진행${event.target.checked ? '' : '해제'}`,
            }
        },

        gaIsNotUseStartDate(event) {
            return {
                view_category: '수강신청작성',
                view_area: '신청시작일사용안함(전송후바로설문)클릭',
                view_label: `사용안함(전송후바로설문)${event.target.checked ? '' : '해제'}`,
            }
        },

        /**
         * 수강신청 유형 변경 시에 이벤트 전파 중단용으로 거는 그냥 아무일도 안 하는 함수
         */
        noop() {
            // do nothing
        },

        onParentClick() {
            this.$eventBus.$emit('parentClick');
        },

        onParentFocus() {
            this.$eventBus.$emit('parentFocus');
        },

        doFocus(elmId) {
            // event 리스너의 순서에 영향을 받지 않기 위해 그냥 다음 콘트롤 플로우 떄 실행한다.
            setTimeout(() => {
                this.$nextTick(() => {
                    document.getElementById(elmId).focus();
                    this.listChange();
                });
            }, 0);
        },

        formValidateTemp() {
            this.stopListChange();

            if (!this.title) {
                this.UICompleted = () => this.doFocus('title');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_inputEnrolmentTitle'),
                };
            }

            if (this.document && this.document.uploadState !== REQUEST_STATE.NONE && this.document.uploadState !== REQUEST_STATE.SUCCESS) {
                this.UICompleted = () => this.doFocus('document');
                return {
                    isValid: false,
                    message: this.$t('common_thereIsUploadingDocument'),
                };
            }

            this.listChange();

            return {
                isValid: true
            };
        },

        formValidate() {
            this.stopListChange();

            if (!this.title) {
                this.UICompleted = () => this.doFocus('title');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_inputEnrolmentTitle'),
                };
            }

            if (!this.surveyDesc) {
                this.UICompleted = () => this.doFocus('surveyDesc');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_inputEnrolmentDesc'),
                };
            }

            if (this.document && this.document.uploadState !== REQUEST_STATE.NONE && this.document.uploadState !== REQUEST_STATE.SUCCESS) {
                this.UICompleted = () => this.doFocus('document');
                return {
                    isValid: false,
                    message: this.$t('common_thereIsUploadingDocument'),
                };
            }

            if (this.isUseStartDate && this.startDateTime <= new Date()) {
                this.UICompleted = () => this.doFocus('startDate');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_startDateFasterThanNow'),
                };
            }

            if (this.endDateTime <= new Date()) {
                this.UICompleted = () => this.doFocus('endDate');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_endDateFasterThanNow'),
                };
            }

            if (this.isUseStartDate && this.startDateTime >= this.endDateTime) {
                this.UICompleted = () => this.doFocus('endDate');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_endDateFasterThanStartDate'),
                };
            }

            if (this.isUseDrawingDate && this.endDateTime > this.drawingDate) {
                this.UICompleted = () => this.doFocus('drawingDate');
                return {
                    isValid: false,
                    message: this.$t('EnrolmentEditor_drawingFasterThanEndDate'),
                };
            }

            if (this.isUseAgreements) {
                // 동의문 사용 시 빈 칸 검증
                for (let i = 0; i < this.agreements.length; i++) {
                    const agreement = this.agreements[i];
                    if (!agreement.question) {
                        this.UICompleted = () => {
                            this.$refs.agree_list.setActiveEditor();
                            this.doFocus(`agreement-title-${i}`);
                        };
                        return {
                            isValid: false,
                            message: this.$t('EnrolmentEditor_inputAgreementTitleNumberN', {i: i + 1}),
                        };
                    }
                    if (!agreement.questionDesc) {
                        this.UICompleted = () => {
                            this.$refs.agree_list.setActiveEditor();
                            this.doFocus(`agreement-desc-${i}`);
                        };
                        return {
                            isValid: false,
                            message: this.$t('EnrolmentEditor_inputAgreementDescNumberN', {i: i + 1}),
                        };
                    }
                }
            }

            for (let i = 0; i < this.questions.length; i++) {
                const question = this.questions[i];

                if (!question.question) {
                    this.UICompleted = () => {
                        this.$refs.list.setActiveEditorIndex(i);
                        this.doFocus(`q${i}`);
                    }
                    return {
                        isValid: false,
                        message: this.$t('EnrolmentEditor_inputQuestionNumberN', {i: i + 1}),
                    };
                }

                for (let j = 0; j < question.programs.length; j++) {
                    const program = question.programs[j];

                    if (!program.programName) {
                        this.UICompleted = () => {
                            this.$refs.list.setActiveEditorIndex(i);
                            this.doFocus(`program-${i}-${j}`);
                        }
                        return {
                            isValid: false,
                            message: this.$t('EnrolmentEditor_inputProgramNumberN', {i: i + 1, j: j + 1}),
                        };
                    }

                  /**
                   * 2024.02.28  수강 신청 개선 건으로 인해서 정원 0명 설정해도 수강신청 서식 등록되도록 수정
                   * 2024.03.07 서버에서 인원 체크 제거 되어야 해서 다시 원복해놓고 서버 작업하면 정원 검증 유효성 제거해야함.
                   * 2024.05.21 0명 설정하면 작성 안되게 수정(예비 인원 지정하면 저장 되어야함)
                   */
                  if (this.enrolmentType !== ENROLMENT_TYPE.RANDOM && !program.limit && !program.reservedLimit) {
                        this.UICompleted = () => {
                            this.$refs.list.setActiveEditorIndex(i);
                            this.doFocus(`limit-${i}-${j}`);
                        }
                        return {
                            isValid: false,
                            message: this.$t('EnrolmentEditor_inputLimitOfProgramNumberN', {i: i + 1, j: j + 1}),
                        };
                    }

                    if (!program.filters.length) {
                        this.UICompleted = () => {
                            this.$refs.list.setActiveEditorIndex(i);
                            this.doFocus(`grade-${i}-${j}-0`);
                        }
                        return {
                            isValid: false,
                            message: this.$t('EnrolmentEditor_invalidGradeRangeOfProgramNumberN', {
                                i: i + 1,
                                j: j + 1,
                            }),
                        };
                    }

                    const intTimes = [];
                    const getOrCalcIntTime = (index) => {
                        if (intTimes[index]) {
                            return intTimes[index];
                        }

                        const {startHour, startMinute, endHour, endMinute} = program.times[index];
                        return intTimes[index] = {
                            startTime: getIntTime({hour: startHour, minute: startMinute}),
                            endTime: getIntTime({hour: endHour, minute: endMinute}),
                        }
                    }

                    for (let k = 0; k < program.times.length; k++) {
                        const time = program.times[k];
                        const indexInfo = {i: i + 1, j: j + 1, k: k + 1};
                        const inputName = ['day', 'startHour', 'startMinute', 'endHour', 'endMinute']
                            .find(name => time[name] === null || time[name] === undefined);

                        if (inputName) {
                            this.UICompleted = () => {
                                this.$refs.list.setActiveEditorIndex(i);
                                this.doFocus(`time-${inputName}-${i}-${j}-${k}`);
                            }
                            return {
                                isValid: false,
                                message: this.$t('EnrolmentEditor_inputTime', indexInfo),
                            };
                        }

                        const {startTime, endTime} = getOrCalcIntTime(k);

                        if (startTime > 2359 || endTime > 2359 || startTime > endTime || startTime === endTime) {
                            this.UICompleted = () => {
                                this.$refs.list.setActiveEditorIndex(i);
                                this.doFocus(`time-startHour-${i}-${j}-${k}`);
                            }
                            return {
                                isValid: false,
                                message: this.$t('EnrolmentEditor_inputTimeInvalid', indexInfo),
                            };
                        }

                        for (let l = k + 1; l <= program.times.length - 1; l++) {
                            const compareTime = program.times[l];
                            if (time.day !== compareTime.day) {
                                continue;
                            }

                            const {startTime: compareStartTime, endTime: compareEndTime} = getOrCalcIntTime(l);
                            if (compareEndTime <= startTime || endTime <= compareStartTime) {
                                continue;
                            }

                            this.UICompleted = () => {
                                this.$refs.list.setActiveEditorIndex(i);
                                this.doFocus(`time-day-${i}-${j}-${k}`);
                            }

                            return {
                                isValid: false,
                                message: this.$t('EnrolmentEditor_inputTimeSame', {
                                    ...indexInfo,
                                    k1: indexInfo.k,
                                    k2: l + 1,
                                }),
                            };
                        }
                    }

                    for (let k = 0; k < program.costs.length; k++) {
                        const cost = program.costs[k];

                        if (cost.value && !cost.name) {
                            this.UICompleted = () => {
                                this.$refs.list.setActiveEditorIndex(i);
                                this.doFocus(`cost-${i}-${j}-${k}`);
                            }
                            return {
                                isValid: false,
                                message: this.$t('EnrolmentEditor_inputCostName', {i: i + 1, j: j + 1, k: k + 1}),
                            };
                        }
                    }
                }
            }

            this.listChange();

            return {
                isValid: true
            };
        },

        getPayload() {
            return {
                ...this[GET_PAYLOAD],
            };
        },

        getRequestInfo() {
            return {
                ...this[GET_REQUEST_INFO],
            };
        },

        downloadTempDocument({action, method}) {
            this.downloadForm.action = action;
            this.downloadForm.method = method;
            this.$nextTick(() => this.$refs.downloadForm.submit());
        },

        toggleAllowDuplicateApply() {
            this.setAllowDuplicateApply({isAllowDuplicateApply: true});
        },

        onMessageEvent(event) {
            switch (event.data.type) {
                case 'UI_COMPLETED':
                    this.UICompleted();
                    break;
                case 'SURVEY_EDITOR_VALIDATE':
                    window.parent.postMessage(
                        {
                            type: 'MAKE_REQUEST',
                            data: {
                                formValidateResult: event.data.data.type === 'TEMP' ? this.formValidateTemp() : this.formValidate(),
                            },
                        },
                        event.origin,
                    );
                    break;
                case 'CLICKED_PARENT':
                    this.onParentClick();
                    break
                case 'FOCUSED_PARENT':
                    this.onParentFocus();
                    break
                case 'RESPONSE_FILTER_INFO_TO_PARENT_WINDOW':
                    this.filterOptions = event.data.data.filterInfo;
                    this.resolveFunc.func();
                    this.clearResolveFunc();
                    break;
                case 'SET_FORM_DATA_FROM_REQUEST_INFO':
                    this.setFormDataFromRequestInfo(event.data.data.setFormDataFromRequestInfo)
                    break;
                case 'SET_FORM_DATA':
                    this.setFormData(event.data.data.setFormData);
                    break;
                case 'GET_REQUEST_INFO':
                    window.parent.postMessage(
                        {
                          type: 'RESULT_GET_REQUEST_INFO',
                          data: {
                              getRequestInfo: this.getRequestInfo(),
                          }
                        },
                        event.origin,
                    )
                    break
                default:
                    break;
            }
        },
    },

    async created() {
        if (inIframe()) {
            window.addEventListener('message', this.onMessageEvent);
            iframeResizeStart();
            // postMessage 먼저 보낼 때
            ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                window.parent.postMessage(
                    {
                      type: 'REQUEST_FILTER_INFO_TO_PARENT_WINDOW',
                    },
                    origin,
                )
            })
            const {promiseInstance, clearResolveFunc, resolveFunc} = usePromise();
            this.clearResolveFunc = clearResolveFunc;
            this.resolveFunc = resolveFunc;
            const res = await promiseInstance();
            if (res === 'false') {
                return;
            }
            this.storeInit({filterOptions: this.filterOptions});
            // postMessage 먼저 보낼 때
            ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                window.parent.postMessage(
                    {
                        type: 'REGISTER_PARENT_WINDOW_ON_PARENT_CLICK',
                    },
                    origin,
                )
                window.parent.postMessage(
                    {
                        type: 'REGISTER_PARENT_WINDOW_ON_PARENT_FOCUS',
                    },
                    origin,
                )
            })

            window.addEventListener('unload', () => {
                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                            type: 'REMOVE_PARENT_WINDOW_ON_PARENT_CLICK',
                        },
                        process.env.VUE_APP_TARGET_ORIGIN,
                    )
                    window.parent.postMessage(
                        {
                            type: 'REMOVE_PARENT_WINDOW_ON_PARENT_FOCUS',
                        },
                        process.env.VUE_APP_TARGET_ORIGIN,
                    )
                })
            });

            this.$nextTick(function () {
                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                          type: 'SURVEY_CREATED',
                          data: {
                              initFormData: getInitForm(),
                          }
                        },
                        origin,
                    )
                })
            });

            this.unsubscribeStore = this.$store.subscribe((mutation, state) => {
                if (mutation.type.indexOf('enrolment') === 0 && mutation.type.indexOf('setStopListChange') < 0) {
                    // postMessage 먼저 보낼 때
                    ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                        window.parent.postMessage(
                            {
                                type: 'SURVEY_FORM_CHANGED',
                            },
                            origin,
                        )
                    })
                }
            });

            window.formValidate = this.formValidate;
            window.formValidateTemp = this.formValidateTemp;
            window.getPayload = this.getPayload;
            window.getRequestInfo = this.getRequestInfo;
        }
    },



    beforeDestroy() {
        if (inIframe()) {
            iframeResizeEnd();
            // postMessage 먼저 보낼 때
            ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                window.parent.postMessage(
                    {
                        type: 'REMOVE_PARENT_WINDOW_ON_PARENT_CLICK',
                    },
                    origin,
                )
                window.parent.postMessage(
                    {
                        type: 'REMOVE_PARENT_WINDOW_ON_PARENT_FOCUS',
                    },
                    origin,
                )
            })
            window.removeEventListener('message', this.onMessageEvent);
        }
    },
}
</script>
